import servicosRotas from './servicos/ServicosRotas'

export default {
    path: 'fornecedores',
    name: 'Gescon_Fornecedores',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        ...servicosRotas
    ]
}